import { Link } from 'react-router-dom'
import { PageMeta } from '../components/seo/PageMeta'
import { pageMeta } from '../lib/seo'

export default function SmsTerms() {
  return (
    <>
      <PageMeta
        title={pageMeta.sms2faTerms.title}
        description={pageMeta.sms2faTerms.description}
        canonical={pageMeta.sms2faTerms.canonical}
      />
      <main className="min-h-screen pt-24 pb-16 px-6">
        <div className="max-w-3xl mx-auto">
          <p className="font-body text-cream-dim text-sm mb-8">Last updated: March 6, 2026.</p>
          <h1 className="font-display font-bold text-2xl uppercase text-white mb-8">
            NextTech Consultants One-Time Passcode (2FA) Program
          </h1>
          <div className="font-body text-cream-dim space-y-6 prose prose-invert max-w-none">
            <p>
              <strong className="text-white">1.</strong> This program sends one-time passcodes via SMS when you log in to the NextTech Consultants website. You receive a single SMS containing your passcode when you attempt to sign in.
            </p>

            <p>
              <strong className="text-white">2.</strong> You can cancel the SMS service at any time. <strong className="text-white">Just text &quot;STOP&quot; to +19712385826.</strong> After you send the SMS message &quot;STOP&quot; to us, we will send you an SMS message to confirm that you have been unsubscribed. After this, you will no longer receive SMS messages from us. If you want to join again, just sign up as you did the first time and we will start sending SMS messages to you again.
            </p>

            <p>
              <strong className="text-white">3.</strong> If you are experiencing issues with the messaging program you can reply with the keyword <strong className="text-white">HELP</strong> for more assistance, or you can get help directly at{' '}
              <a href="mailto:info@nexttechconsultants.com" className="text-accent hover:underline">info@nexttechconsultants.com</a> or 971.238.4801.
            </p>

            <p>
              <strong className="text-white">4.</strong> Carriers are not liable for delayed or undelivered messages.
            </p>

            <p>
              <strong className="text-white">5.</strong> As always, message and data rates may apply for any messages sent to you from us and to us from you. You receive one-time passcode messages only when you attempt to log in. If you have any questions about your text plan or data plan, it is best to contact your wireless provider.
            </p>

            <p>
              <strong className="text-white">6.</strong> If you have any questions regarding privacy, please read our{' '}
              <Link to="/privacy" className="text-accent hover:underline">Privacy Policy</Link>.
            </p>
          </div>
        </div>
      </main>
    </>
  )
}
